import { Attachment } from 'models/attachments.model'
import api from '../..'

export interface DownloadUsersOpts {
  disabled?: boolean
}

const downloadUsers = ({ disabled }: DownloadUsersOpts) => {
  return api.get<string | Attachment>('administration/users/download', {
    params: {
      disabled,
    },
  })
}

export default downloadUsers
